import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 834 (croisière) — le voyageur confirme TWIN ou GRAND LIT pour chaque chambre à 2, avant l'envoi de la rooming list
export const LiterieChoix = ({ token, literie, onChange, verrouille = false }) => {
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState('');
  if (!literie?.chambres?.length) return null;
  const choisir = async (index, typeChambre) => {
    setBusy(`${index}-${typeChambre}`); setErr('');
    try {
      const r = await axios.post(`${API}/pieces-identite/${token}/literie`, { index, typeChambre });
      onChange?.(r.data.literie);
    } catch (e) { setErr(e.response?.data?.detail || "Enregistrement impossible, réessayez."); }
    setBusy(null);
  };
  const aConfirmer = literie.chambres.some(c => c.a_confirmer);
  return (
    <div className={`rounded-xl p-4 border-2 ${aConfirmer ? 'border-amber-400 bg-amber-50' : 'border-emerald-300 bg-emerald-50'}`} data-testid="literie-bloc">
      <p className="font-bold text-[#1E3A5F] text-sm">🛏️ Literie des chambres {aConfirmer ? <span className="text-amber-800">— à confirmer</span> : <span className="text-emerald-700">— confirmée ✅</span>}</p>
      <p className="text-xs text-gray-700 mt-1">La compagnie prépare les cabines à l'avance : indiquez pour chaque chambre à 2 personnes <strong>TWIN</strong> (2 lits séparés) ou <strong>GRAND LIT</strong> (1 lit double).</p>
      <div className="mt-3 space-y-2">
        {literie.chambres.map(c => (
          <div key={c.index} className="bg-white rounded-lg border border-gray-200 px-3 py-2" data-testid={`literie-chambre-${c.index}`}>
            <p className="text-xs font-semibold text-gray-800">Chambre {c.index + 1} · {c.occupants.join(' & ')}</p>
            {c.modifiable && verrouille ? (
              <p className="text-xs text-gray-700 mt-1">🔒 {c.typeChambre ? literie.choix[c.typeChambre] || c.typeChambre : 'Non choisie'} — liste transmise à la compagnie, appelez-nous pour changer.</p>
            ) : c.modifiable ? (
              <div className="flex gap-2 mt-1.5">
                {Object.entries(literie.choix).map(([k, lab]) => (
                  <button key={k} type="button" disabled={busy !== null} onClick={() => choisir(c.index, k)} data-testid={`literie-${c.index}-${k}`}
                    className={`flex-1 text-xs font-bold rounded-lg px-2 py-2 border-2 transition-colors ${c.typeChambre === k ? 'bg-[#1E3A5F] border-[#1E3A5F] text-white' : 'bg-white border-gray-300 text-[#1E3A5F] hover:border-[#1E3A5F]'}`}>
                    {busy === `${c.index}-${k}` ? '…' : lab}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-xs text-gray-500 mt-1">{c.occupants.length === 1 ? 'Chambre individuelle' : `${c.occupants.length} personnes — lits séparés`} (pas de choix à faire).</p>
            )}
          </div>
        ))}
      </div>
      {err && <p className="text-xs font-bold text-red-700 mt-2" data-testid="literie-err">{err}</p>}
    </div>
  );
};
